import type React from "react"
import { useEffect, useRef } from "react"
import { Card } from "react-bootstrap"
import * as echarts from "echarts";

// @ts-ignore
const MultiBarChart: React.FC = ({ MultiBarChartData }) => {
    const chartRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!chartRef.current) return

        const chart = echarts.init(chartRef.current)

        const option = {
            title: {
                text: MultiBarChartData?.title,
                textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    color: "#18181B",
                    lineHeight: 16
                },
                left: 0,
                top: 0,
                subtext: MultiBarChartData?.subtitle,
                subtextStyle: {
                    fontSize: 14,
                    color: "#838FB4",
                    fontWeight: 400,
                    lineHeight: 16,
                    width: 700,
                    overflow: "break"
                }
            },
            tooltip: {
                trigger: "axis",
            },
            legend: {
                data: MultiBarChartData && MultiBarChartData?.series?.map((item: any) => item.name),
                bottom: 0,
                itemGap: 20,
                icon: 'circle'
            },
            grid: {
                top: "25%",
                bottom: "25%",
            },
            xAxis: {
                type: "category",
                data: MultiBarChartData?.xAxis?.categories,
                name: MultiBarChartData?.xAxis?.name,
                nameLocation: "middle",
                nameGap: 30,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400,
                    rotate: 45,
                    formatter: function (value: string) {
                        const maxLength = 10;
                        return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                    }
                },
            },
            yAxis: {
                type: "value",
                name: MultiBarChartData?.yAxis?.name,
                nameLocation: "middle",
                nameRotate: 90,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: "rgba(0, 102, 204, 0.25)"
                    }
                },
            },
            series: MultiBarChartData?.series?.map((s:any, index:number) => ({
                name: s?.name,
                type: "bar",
                data: s?.data,
                barMaxWidth: 50,
                itemStyle: {
                    color: index === 0 ? "#0066CC" : "#7784F5"
                }
            })) || [],
        }

        chart.setOption(option)

        const handleResize = () => {
            chart.resize()
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
            chart.dispose()
        }
    }, [MultiBarChartData])

    return (
        <Card className="h-100 shadow-sm">
            <Card.Body className="p-3">
                <div ref={chartRef} style={{ width: "100%", height: "400px" }} />
            </Card.Body>
        </Card>
    )
}

export default MultiBarChart;
